/**
 * Mémoire locale de la session — pour ne PAS être déconnecté hors-ligne.
 *
 * LE BUG QUE CE FICHIER CORRIGE
 *
 * `useSession` de better-auth interroge le serveur. Hors-ligne, cet appel
 * échoue, la session paraît absente, et l'app affiche l'écran de connexion —
 * qu'on ne peut évidemment pas franchir sans réseau. Autrement dit : ouvrir
 * Popote dans un sous-sol de supermarché déconnectait l'utilisateur, très
 * exactement là où l'app doit être la plus fiable.
 *
 * LA PARADE, ET SA LIMITE ASSUMÉE
 *
 * On retient localement de qui il s'agit, et l'interface fait confiance à
 * cette mémoire quand le réseau manque. Ce n'est PAS un contournement
 * d'authentification : le serveur reste seul juge, `/api/sync` répond 401
 * si la session est réellement morte, et la pastille le dit alors
 * franchement. Ce qui est stocké ici — un identifiant et un prénom — n'ouvre
 * aucun accès en soi.
 *
 * localStorage et non IndexedDB : c'est lu de façon SYNCHRONE au premier
 * rendu, avant toute promesse, ce qui évite un éclair d'écran de connexion
 * au démarrage.
 */

const CLE = 'popote:session'

export type SessionLocale = { userId: string; householdId: string; prenom: string }

export function lireSessionLocale(): SessionLocale | null {
  try {
    const brut = localStorage.getItem(CLE)
    if (!brut) return null
    const s = JSON.parse(brut) as SessionLocale
    return s.userId ? s : null
  } catch {
    // Safari en navigation privée peut jeter : on retombe simplement sur
    // « pas de session connue », ce qui est le comportement d'avant.
    return null
  }
}

export function ecrireSessionLocale(s: SessionLocale): void {
  try {
    localStorage.setItem(CLE, JSON.stringify(s))
  } catch {
    /* sans effet : l'app marche, elle redemandera la session au serveur */
  }
}

export function oublierSessionLocale(): void {
  try {
    localStorage.removeItem(CLE)
  } catch {
    /* rien à faire */
  }
}
